import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '@/lib/contexts/AuthContext'
import { verifyMagicLink } from '@/lib/api/api'
import { SystemCardShell, SystemCardHeading, SystemCardPrimary, SystemCardProgress } from '@/components/shared/layout'

export default function Me() {
  const [loaded, setLoaded] = useState(false)
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { setToken } = useAuth()

  useEffect(() => {
    const handleMagicLink = async () => {
      const t = searchParams.get('t')
      const p = searchParams.get('p')
      const n = searchParams.has('n')

      if (!t || !p) {
        setLoaded(true)
        return
      }

      try {
        const authToken = await verifyMagicLink(t, p, n)
        
        if (authToken) {
          // Set token using AuthContext
          setToken(authToken)
          
          // Redirect to dashboard (pricing modal will show via paywall logic if needed)
          navigate('/dashboard')
        } else {
          setLoaded(true)
        }
      } catch (error) {
        console.error(error)
        setLoaded(true)
      }
    }

    handleMagicLink()
  }, [searchParams, navigate, setToken])

  if (!loaded) {
    return (
      <SystemCardShell>
        <SystemCardHeading eyebrow="Sign in" title="Signing you in">
          Checking your sign-in link.
        </SystemCardHeading>
        <SystemCardProgress label="Verifying link" />
      </SystemCardShell>
    )
  }

  return (
    <SystemCardShell>
      <SystemCardHeading eyebrow="Sign in" title="This sign-in link has expired">
        Sign in again to get a fresh link.
      </SystemCardHeading>
      <SystemCardPrimary onClick={() => navigate('/auth?mode=signin')}>Sign in again</SystemCardPrimary>
    </SystemCardShell>
  )
}
